var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { "label-width": "0" } },
        [
          _c("el-divider", { staticClass: "custom-divider" }, [
            _vm._v(_vm._s(_vm.i18nt("designer.setting.columnSetting"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.i18nt("designer.setting.gutter") } },
        [
          _c("el-input-number", {
            staticStyle: { width: "100%" },
            model: {
              value: _vm.optionModel.gutter,
              callback: function ($$v) {
                _vm.$set(_vm.optionModel, "gutter", $$v)
              },
              expression: "optionModel.gutter",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", {
        attrs: { label: _vm.i18nt("designer.setting.colsOfGrid") },
      }),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { "label-width": "0" } },
        [
          _vm._l(_vm.selectedWidget.cols, function (colItem, colIdx) {
            return _c(
              "li",
              { key: colIdx, staticClass: "col-item" },
              [
                _c("span", { staticClass: "col-span-title" }, [
                  _vm._v("栅格宽度" + _vm._s(colIdx + 1)),
                ]),
                _vm._v(" "),
                _c("el-input-number", {
                  staticClass: "cell-span-input",
                  attrs: { min: 1, max: 24 },
                  on: {
                    change: function (newValue, oldValue) {
                      return _vm.spanChanged(
                        _vm.selectedWidget,
                        colItem,
                        colIdx,
                        newValue,
                        oldValue
                      )
                    },
                  },
                  model: {
                    value: colItem.options.span,
                    callback: function ($$v) {
                      _vm.$set(colItem.options, "span", _vm._n($$v))
                    },
                    expression: "colItem.options.span",
                  },
                }),
                _vm._v(" "),
                _c("el-button", {
                  staticClass: "col-delete-button",
                  attrs: {
                    circle: "",
                    plain: "",
                    size: "mini",
                    type: "danger",
                    icon: "el-icon-minus",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.deleteCol(_vm.selectedWidget, colIdx)
                    },
                  },
                }),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.addNewCol(_vm.selectedWidget)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.i18nt("designer.setting.addColumn")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }